import state from './moduleManningVesselListState.js'
import mutations from './moduleManningVesselListMutations.js'
import actions from './moduleManningVesselListActions.js'
import getters from './moduleManningVesselListGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
